export const deployLocation = process.env.REACT_APP_API_URL;
export const authUrl = "/auth";
export const CLARA_CONTAINER_NAME = "at.ac.mdw.trompa/";
